export enum ChannelStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  DECLINED = 'DECLINED',
}

export interface Channel {
  id: string;
  url: string;
  status: string;
  createdAt: string;
}
